import {
  Badge,
  Box,
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { apiPipeline } from "api/api-pipeline";
import { CustomModal } from "components/custom-modal";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useEffect, useState } from "react";

export type ModalDetalhesErroParams = {
  stateId: number;
  errorCode: number;
  errorLabel: string;
};

type ErroDetalhe = {
  code: number | null;
  statusDescription: string | null;
  total: number;
};

const eventName = "openModalDetalhesErro";

export const openModalDetalhesErro =
  createModalTrigger<ModalDetalhesErroParams>(eventName);

export function ModalDetalhesErro() {
  const [items, setItems] = useState<ErroDetalhe[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { isOpen, onClose, params } = useModalControls<ModalDetalhesErroParams>(
    eventName,
    {
      onOpen(p) {
        if (!p?.stateId) return;
        setItems([]);
        setError(null);
        setIsLoading(true);
        apiPipeline
          .get<ErroDetalhe[]>(
            `/pipeline-new/state/${p.stateId}?errorCode=${p.errorCode}`
          )
          .then(({ data }) => setItems(data ?? []))
          .catch(() => setError("Não foi possível carregar os detalhes."))
          .finally(() => setIsLoading(false));
      },
      onClose() {
        setItems([]);
        setError(null);
      }
    }
  );

  const title = params.errorLabel
    ? `Detalhes: ${params.errorLabel}`
    : "Detalhes do erro";

  return (
    <CustomModal modalTitle={title} isOpen={isOpen} onClose={onClose} size="lg">
      <Box minH="80px">
        {isLoading && (
          <Flex align="center" justify="center" py={8}>
            <Spinner size="md" color="blue.400" />
          </Flex>
        )}

        {!isLoading && error && (
          <Text color="red.500" fontSize="sm" py={4} textAlign="center">
            {error}
          </Text>
        )}

        {!isLoading && !error && items.length === 0 && (
          <Text color="gray.400" fontSize="sm" py={4} textAlign="center">
            Nenhum detalhe encontrado.
          </Text>
        )}

        {!isLoading && !error && items.length > 0 && (
          <Table size="sm" variant="simple">
            <Thead>
              <Tr>
                <Th>Descrição</Th>
                <Th isNumeric>Código</Th>
                <Th isNumeric>Total</Th>
              </Tr>
            </Thead>
            <Tbody>
              {items.map((item, i) => (
                <Tr key={i}>
                  <Td>
                    <Text fontSize="sm">{item.statusDescription ?? "—"}</Text>
                  </Td>
                  <Td isNumeric>
                    {item.code != null ? (
                      <Badge
                        colorScheme={item.code >= 400 ? "red" : "green"}
                        fontSize="xs"
                      >
                        {item.code}
                      </Badge>
                    ) : (
                      <Text fontSize="xs" color="gray.400">
                        —
                      </Text>
                    )}
                  </Td>
                  <Td isNumeric>
                    <Badge colorScheme="blue" fontSize="xs">
                      {item.total}
                    </Badge>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </Box>
    </CustomModal>
  );
}
